<template>
	<div class="bidDetail">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>招标详情</span>
			<div></div>
		</div>
		<!-- 详细内容 -->
		<div class="container">
			<!-- 标题 -->
			<van-cell size="large">
				<div slot="title" class="container_title">
					{{detail.title}}
				</div>
				<div slot="label" class="container_label">
					<span>时间:&nbsp;{{detail.create_time}}&nbsp;</span>
					<span>浏览:&nbsp;{{detail.browse}}</span>
				</div>
			</van-cell>
			<!-- 内容 -->
			<div class="content" ref="richText" v-html='detail.content'></div>
			<!-- 说明 -->
			<div class="tips">
				特别注意：俱百家商城（<a href="http://www.jbj-china.com.cn/Home">www.jbj-china.com.cn</a>）所提供的招投标信息资源均来自于互联网，版权归原网站所有，如果您认为本站有侵犯您权益的行为，请您联系我们，我们会立即做出答复并及时解决。
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				detail: []
			}
		},
		created() {
			let that = this;
			//新闻列表
			that.$axios.post(baseUrl + '/mobile/Base/bidInfo', {
				id: that.$route.query.id
			}).then(function(res) {
				if (res.data.code == 2) {
					that.detail = res.data.data;
					var imgReg = /<img.*?(?:>|\/>)/gi;
					var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
					var arr = that.detail.content.match(imgReg);
					for (var i = 0; i < arr.length; i++) {
						var src = arr[i].match(srcReg);
						if (src[1]) {
							// //获取图片地址
							that.detail.content = that.detail.content.replace(src[1],
								baseUrl + src[1]);
						}
					}
					var regex1 = new RegExp("(i?)(\<img)(?!(.*?style=['\"](.*)['\"])[^\>]+\>)", "gmi");
					//给不含style="" 或 style='' 的img标签加上style=""
					that.detail.content = that.detail.content.replace(regex1, "$2 style=\"\"$3");
					//正则匹配含有style的img标签
					var regex2 = new RegExp("(i?)(\<img.*?style=['\"])([^\>]+\>)", "gmi");
					that.detail.content = that.detail.content.replace(regex2,
						"$2max-width:100%;width:100%;height:auto;$3");
				}
			}).catch(function(err) {
				console.log(err);
			});
		}
	}
</script>

<style scoped>
	@import "bidDetail.css";
</style>



// WEBPACK FOOTER //
// src/components/home/bidDetail.vue